const PulsingDots = ({ color = "nelo-blue" }: { color?: string }) => {
  return (
    <div className="my-8 flex justify-center space-x-2">
      <div className={`bg-${color} h-4 w-4 animate-pulse rounded-full`}></div>
      <div className={`bg-${color} h-4 w-4 animate-pulse rounded-full animation-delay-300`}></div>
      <div className={`bg-${color} h-4 w-4 animate-pulse rounded-full animation-delay-600`}></div>
      <div className={`bg-${color} animation-delay-900 h-4 w-4 animate-pulse rounded-full`}></div>
    </div>
  )
}

export default PulsingDots
